export interface ICartData {
  _id: string;
  createdAt: string;
  updatedAt: string;
  userId: string;
  userType: string;
  subTotal: number;
  totalShipmentCapacity: number;
taxAmount: number;
  shipmentCharges: number;
  totalPrice: number;
  cartItems: ICartItems[];
}
export interface ICartItems {
  _id: string;
  createdAt: string;
  updatedAt: string;
  userId: string;
  cartId: string;
  categoryId: string;
  subCategoryId: string;
  productId: string;
  quantity: number;
  productTitle: string;
  packageId: string;
  packageTitle: string;
  groupId: string;
  price: number;
  featuredImage: string;
  itemType: CartItemType;
  shipmentCapacity: number;
  taxAmount: number;
  taxRate: number;
  cart_package_items: [];
}
export interface ICheckout {
  // _id:string;

  // district: string;
  // state: string;
  // village:string;
  // streetAddress: string;
  // mobileNumber: string;
  // email:string;
  // companyName: string;
  // japaneseCompanyName: string;
  // department: string;
  // remark: string;
  // timeZone: string;

  customerInfo: {
    firstName: string;
    lastName: string;
    japaneseFirstName: string;
    japaneseLastName: string;
    postCode: string;
    state: string;
    district: string;
    streetAddress: string;
    mobileNumber: string;
    email: string;
    companyName: string;
    japaneseCompanyName: string;
    department: string;
  };
  sameAsCustomerInfo: boolean;
  shippingAddress: {
    firstName: string;
    lastName: string;
    japaneseFirstName: string;
    japaneseLastName: string;
    postCode: string;
    district: string;
    state: string;
    streetAddress: string;
    mobileNumber: string;
    companyName: string;
    japaneseCompanyName: string;
    department: string;
  };
  remarks: string;
  paymentMethod: paymentMethodType;
  deliveryTimeSlot: string;
}
export enum CartItemType {
  PRODUCT = "product",
  PACKAGE = "package",
}
export enum paymentMethodType {
  stripe = "stripe",
  cash_on_delivery = "cash_on_delivery",
  invoice_based = "invoice_based",
  store_payment = "store_payment",
}

export interface IBookingProceed {
  orderId: string;
  payment_id: string;
  key: string;
  public_key: string;
  paymentMethod: paymentMethodType;
}
export interface IAddCartData {
  packageItems?: { groupId: string; productId: string }[];
  productId?: string;
  packageId?: string;
  quantity: number;
}
export interface IState {
  _id: string;
  name: string;
}
export interface IStore {
  _id: string;
  title: string;
}

export interface ICartSummary {
  shipmentCharges: number;
  subTotal: number;
  taxAmount: number;
  totalPrice: number;
}
export interface CartAddState {
  list: ICartData;
  offlineList: IAddCartData[];
  stateList: IState[];
  storeList: IStore[];
  checkoutForm: ICheckout;
  bookingProceedForm: IBookingProceed;
  cartSummary: ICartSummary;
  loading: boolean;
  buttonLoading: boolean;
  search: string;
  pageNo: number;
  pageSize: number;
  totalRow: number;
  orderBy: string;
  orderDir: string;
}

export type InitialState = CartAddState;
